/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2FyaWFkbmFlcmNpbGxhbW9udHNlcnJhdC9EZXNrdG9wL0ZFSU5BL3BvcnRmb2xpby9wb3J0Zm9saW9fYXJpL3NyYy9hcHAvcG9ydGZvbGlvLXNhbHRpbmJhbnF1aW4vcG9ydGZvbGlvLXNhbHRpbmJhbnF1aW4uY29tcG9uZW50LnNhc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvYXJpYWRuYWVyY2lsbGFtb250c2VycmF0L0Rlc2t0b3AvRkVJTkEvcG9ydGZvbGlvL3BvcnRmb2xpb19hcmkvc3JjL2FwcC9wb3J0Zm9saW8tc2FsdGluYmFucXVpbi9wb3J0Zm9saW8tc2FsdGluYmFucXVpbi5jb21wb25lbnQuc2FzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/portfolio-saltinbanquin/portfolio-saltinbanquin.component.sass.shim.ngstyle.ts